// main.js
import { createApp } from 'vue';
import App from './App.vue'; // 注意：Vue 3 推荐添加 .vue 后缀（确保文件存在）

// 状态管理
import store from './store';
// 路由
import router from './router';
// HTTP 请求（Axios）
import axios from 'axios';
// UI 库：Vant（按需引入 + 完整引入冲突，选择一种即可，推荐按需引入）
import { Button, Uploader, NavBar, Dialog, Toast } from 'vant';
import 'vant/lib/index.css';
// UI 库：Element Plus
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';



// ========== 1. 创建 Axios 实例（全局配置） ==========http://121.196.244.199:8056
const service = axios.create({
    baseURL: 'http://121.196.244.199:8057', // 正式环境接口地址
    timeout: 5000, // 请求超时时间（5秒）
    headers: {
        'Content-Type': 'application/json;charset=UTF-8' // 默认请求头
    }
});

// 请求拦截器：自动添加 Token（适配后端 JWT 拦截器）
service.interceptors.request.use(
    (config) => {
        // 从 localStorage 获取 Token（与 store 中存储的 Key 一致）
        const token = localStorage.getItem('AUTH_TOKEN');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; // 格式：Bearer + 空格 + Token
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 响应拦截器：统一处理响应结果（适配后端 ApiResponse 格式）
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        // 假设后端返回格式：{ code: 200, data: {}, message: "" }
        if (res.code !== 200) {
            // 错误提示（可结合 Element Plus 的 ElMessage 优化）
            console.error(`接口请求失败：${res.message || '未知错误'}`);
            return Promise.reject(res);
        }
        return res.data; // 直接返回 data 字段，简化组件中使用
    },
    (error) => {
        // 网络错误/401/500 等处理
        const message = error.response.data.message || '网络请求失败，请稍后重试';
        console.error(`网络错误：${message}`);
        // Token 过期（401）：清除 Token 并跳转登录页
        if (error.response.status === 401) {
            localStorage.removeItem('AUTH_TOKEN');
            router.push('/denglu'); // 跳转登录页（需确保路由存在）
        }
        return Promise.reject(error);
    }
);

// ========== 2. 创建 Vue 3 应用实例 ==========
const app = createApp(App);


app.use(ElementPlus, {
    locale: zhCn, // 设置中文语言
});

// ========== 3. 全局注册依赖 ==========
// 3.1 注册 Element Plus 图标（全局可用）
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

// 3.2 注册 UI 组件库
app.use(ElementPlus, {
    locale: zhCn, // 使用中文包
});
app.use(Button); // 按需使用 Vant 组件（已导入的 Button/Uploader/NavBar）
app.use(Uploader);
app.use(NavBar);
app.use(Dialog);
app.use(Toast);

// 3.3 挂载路由和状态管理
app.use(router); // 挂载 Vue Router
app.use(store); // 挂载 Vuex

// 3.4 全局挂载 Axios 实例（组件中可通过 this.$axios 或 inject 使用）
app.config.globalProperties.$axios = service; // 全局挂载（Options API 可用）
app.provide('axios', service); // 依赖注入（Composition API 可用）

// ========== 4. 挂载根组件 ==========
app.mount('#app'); // 唯一挂载点（对应 public/index.html 中的 #app）